import { Component, OnInit } from '@angular/core';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { GwrGrundstueckListEntry, GwrWohnungDetailEntry, GwrWohnungSearchByIdResponse, GwrwohnungService } from '../../../core/gwr-api';
import { switchMap } from 'rxjs/operators';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { Location } from '@angular/common';
import { AbstractComponent } from '../../../shared/components/abstract-component/abstract.component';
import { ListLoader } from '../../../shared/components/list-loader/list-loader';
import { ListLoaderPreloaded } from '../../../shared/components/list-loader/list-loader-preloaded';
import { CapAlertService } from '../../../core/extension/exceptions/cap-alert.service';
import { CapAlertLevel } from '../../../core/extension/exceptions/cap-alert-level.enum';
import { GwrStatus } from '../../../shared/enum/GwrStatus';
import { ContentHeaderComponent } from '../../../shared/components/content-header/content-header.component';
import { TitleComponent } from '../../../shared/components/title/title.component';
import { KopfdatenelementComponent } from '../../../shared/widgets/kopfdatenelement/kopfdatenelement.component';
import { GwrGrundstueckTableComponent } from '../../gwr-grundstueck-list/gwr-grundstueck-table.component';
import { CapSpinnerSmallComponent } from '../../../shared/components/cap-spinner-small/cap-spinner-small.component';
import { DecimalHochkommaPipe } from '../../../shared/pipes/simple/decimalHochkomma.pipe';
import { GwrBaujahrPeriodePipe } from '../../gwr-gebaeude/gwr-baujahr-periode-pipe';
import { KompaktGwrGebaeudeeingangsadressePipe } from '../../gwr-gebaeude/kompakt-gebaeudeeingangsadresse-pipe';

@Component({
  selector: 'cap-gwr-wohnung-detail',
  templateUrl: './gwr-wohnung-detail.component.html',
  styleUrls: ['./gwr-wohnung-detail.component.scss'],
  imports: [
    ContentHeaderComponent,
    TitleComponent,
    KopfdatenelementComponent,
    GwrGrundstueckTableComponent,
    CapSpinnerSmallComponent,
    DecimalHochkommaPipe,
    GwrBaujahrPeriodePipe,
    KompaktGwrGebaeudeeingangsadressePipe,
    TranslatePipe
  ]
})
export class GwrWohnungDetailComponent extends AbstractComponent implements OnInit {
  public wohnung: GwrWohnungDetailEntry;

  grundstueckListLoader: ListLoader<GwrGrundstueckListEntry>;

  constructor(
    private translate: TranslateService,
    private wohnungService: GwrwohnungService,
    private route: ActivatedRoute,
    private location: Location,
    private capAlertService: CapAlertService
  ) {
    super();
    keysToTranslate<string>([
      'AdminWohnungsnummer',
      'Adresse',
      'AnzahlZimmer',
      'KuecheVorhanden',
      'LageAufStockwerk',
      'Mehrgeschossig',
      'Stockwerk',
      'Wohnungsflaeche',
      'Wohnungsstatus',
      'Wohnungsnummer',
      'gehoertZuGrundstueck'
    ]);
    keysToTranslate<GwrWohnungDetailEntry.WohnungsstatusEnum>([
      'PROJEKTIERT',
      'BEWILLIGT',
      'IM_BAU',
      'BESTEHEND',
      'NICHT_NUTZBAR',
      'AUFGEHOBEN',
      'NICHT_REALISIERT'
    ]);
  }

  ngOnInit() {
    this.route.params.subscribe((params) => {
      this.addSub(
        this.route.paramMap
          .pipe(
            switchMap((paramMap: ParamMap) => {
              const requestParamEgid = paramMap.get('egid');
              const requestParamEwid = paramMap.get('ewid');
              if (requestParamEgid && requestParamEwid) {
                return this.wohnungService.loadWohnungByEgidEwid(+requestParamEgid, +requestParamEwid);
              }
            })
          )
          .subscribe({
            next: (response) => this.fillWohnungFrom(response),
            error: (err) => this.handleError(err)
          })
      );
    });
  }

  private fillWohnungFrom(response: GwrWohnungSearchByIdResponse) {
    const wsStatus = response.gwrStatusCode;
    if (wsStatus.statusCode !== GwrStatus.OK) {
      const alertText = this.translate.instant('FehlerBeimAufrufDesWebservice');
      this.capAlertService.warning(`${alertText}: ${wsStatus.statusCode} (${wsStatus.text})`, CapAlertLevel.CONTENT_HEADER, true);
      this.navigateBackToSearch();
    }
    this.wohnung = response.result;
    this.initGrundstueckListLoader(response.result.grundstuecke);
  }

  initGrundstueckListLoader(grundstuecke: Array<GwrGrundstueckListEntry>) {
    this.grundstueckListLoader = new ListLoaderPreloaded<GwrGrundstueckListEntry>(15, 1, grundstuecke);
    this.addLoader(this.grundstueckListLoader);
  }

  navigateBackToSearch() {
    this.location.back();
  }

  private handleError(err) {
    if (err.status === 400) {
      this.location.back();
    }
    throw err;
  }
}
